import Vue from 'vue';
import i18n from '@/locales';
import {
	getBaseUrl,
	helperSignIn,
	helperSignOut,
	postToServer,
	clearSession,
	luaScript
} from '../helpers/helper_store';
const state = {
	user: null,
	config: null,
	loading: false,
	error: null,
	errorsArray: [],
	base: {
		url: null,
		label: null
	},
	menu: null,
	theme: null,
	userDenial: null,
	mainServerVersion: null
};

const mutations = {
	setUser: (state, user) => (state.user = user),
	setRoleId: (state, roleid) => (state.user.roleid = roleid),
	setConfig: (state, config) => (state.config = config),
	setError(state, error) {
		state.error = error;
		//console.log('stating error', error);
		//console.log(state.errorsArray);
		if (error !== null) {
			if (state.errorsArray.length > 2) {
				state.errorsArray.shift();
			}
			state.errorsArray.push(error);
		}
	},
	setBase: (state, base) => (state.base = base),
	setLoading: (state, data) => (state.loading = data),
	setMenu: (state, data) => {
		state.menu = data;
		Vue.localStorage.set('wa-menu', data);
	},
	setTheme: (state, data) => {
		state.theme = data;
		Vue.localStorage.set('wa-theme', data);
	},
	setUserDenial: (state, data) => (state.userDenial = data),
	setMainVers: (state, data) => (state.mainServerVersion = data)
};

const actions = {
	getConfig({ commit, state, dispatch }) {
		//передаю функцию commit глобальному объекту window - для того, чтобы доставать из checkResponse
		//с большой вероятностью - костыль, еще подумаю
		window.commit = commit;
		let theme = Vue.localStorage.get('wa-theme');
		if (!!theme && theme !== 'null') {
			commit('setTheme', theme);
		} else commit('setTheme', 'dark');
		let menu = Vue.localStorage.get('wa-menu');
		if (!!menu && menu !== 'null') {
			commit('setMenu', menu);
		} else commit('setMenu', 'full');
		return new Promise((resolve, reject) => {
			Vue.axios
				.get(__webpack_public_path__ + 'config.json')
				.then((response) => {
					let debugConnection = response.data.connections.find((connection) =>
						connection.url.includes('localhost')
					);
					let checkDebug = Vue.localStorage.get('wa-debug');
					if (checkDebug !== '1' && debugConnection) {
						for (let i = 0; i < response.data.connections.length; i++) {
							if (response.data.connections[i].url.includes('localhost')) {
								response.data.connections.splice(i, 1);
								i--;
							}
						}
					}
					commit('setConfig', response.data);
					const denial = [
						{
							roleid: "-1",
							deniedLinkNames: [
								'multiTaskLink',
								'processesLink',
								'servicesLink',
								'visualsLink',
								'configTreeLink',
								'configTasksLink',
								'roleSectionsLink',
								'roleTasksLink',
								'sectionTasksLink',
								'referenceBasesLink',
								'referenceSectionsLink',
								'referenceServersLink',
								'referenceUsersLink',
								'referenceRolesLink',
								'referenceAppParamsLink',
								'referenceUpgradesLink',
								'schedulerLink',
								'schedulerHistoryLink'
							]
						},
						{
							roleid: '0',
							deniedLinkNames: []
						},
						{
							roleid: '1',
							deniedLinkNames: [
								'referenceBasesLink',
								'referenceSectionsLink',
								'referenceServersLink',
								'referenceAppParamsLink',
								'configTreeLink',
								'configTasksLink',
								'visualsLink',
								'sectionTasksLink'
							]
						},
						{
							roleid: '2',
							deniedLinkNames: [
								'multiTaskLink',
								'processesLink',
								'servicesLink',
								'logsLink',
								'visualsLink',
								'configTreeLink',
								'configTasksLink',
								'roleSectionsLink',
								'roleTasksLink',
								'sectionTasksLink',
								'referenceBasesLink',
								'referenceSectionsLink',
								'referenceServersLink',
								'referenceUsersLink',
								'referenceRolesLink',
								'referenceAppParamsLink',
								'referenceUpgradesLink',
								'schedulerLink',
								'schedulerHistoryLink'
							]
						}
					];
					commit('setUserDenial', denial);

					// let waConnection = '';
					const savedConnection = Vue.localStorage.get('wa-connection');
					if (savedConnection) {
						const connect = JSON.parse(savedConnection);
						const login = connect.login;
						const language = connect.language;
						const connection = connect.connection;
						if (state.config.connections.length === 0) {
							commit('setError', 'Ошибка настройки конфигурационного файла');
						}
						let url, label;
						const findConnection = getBaseUrl(state.config, connection);
						if (findConnection.length > 0) {
							url = findConnection[0].url;
							label = findConnection[0].label;
						} else {
							url = state.config.connections[0].url;
							label = state.config.connections[0].label;

							const waConnection = {
								login,
								language,
								connection: state.config.connections[0].value
							};
							Vue.localStorage.set('wa-connection', JSON.stringify(waConnection));
						}
						commit('setBase', { url, label });
					} else {
						clearSession();
						i18n.locale = response.data.languages[0].value;
					}
					resolve();
				})
				.catch((error) => {
					commit('setError', error + ' from login get connection');
					reject();
				});
		});
	},
	getRoleId({ commit, state }) {
		return new Promise((resolve, reject) => {
			//console.log('In getRoleId', state.user.userid);
			luaScript('getRole', 'getRole', { userid: state.user.userid }, state)
				.then((result) => {
					//console.log('RESULT: ', result);
					commit('setRoleId', result.idRole[0]);
					let saved = JSON.parse(Vue.localStorage.get('wa-auth'));
					saved.mpj = result.idRole[0];
					Vue.localStorage.set('wa-auth', JSON.stringify(saved));
					//console.log('saved: ', saved);
					resolve();
				})
				.catch(() => {
					//console.log('IN CATCH');
					reject();
				});
		});
	},
	signIn({ commit, state }, { username, password, language, connection }) {
		if (state.config.connections.length === 0) {
			commit('setError', 'Config file error');
			return;
		}
		let url, label;
		const findConnection = getBaseUrl(state.config, connection);
		// console.log(findConnection);
		if (findConnection.length > 0) {
			url = findConnection[0].url;
			label = findConnection[0].label;
		} else {
			url = state.config.connections[0].url;
			label = state.config.connections[0].label;
			connection = state.config.connections[0].value;
		}
		commit('setBase', { url, label });

		/* 	if (getBaseUrl(state.config, connection)) {
			commit('setBase', getBaseUrl(state.config, connection));
		}
		else {
			commit('setError', 'No connections in config.json');
		} */

		let objectToServer = {
			cmd: 'auth',
			login: username,
			passwd: password,
			lang: language
		};
		helperSignIn(objectToServer, state.base.url, connection, language);
	},
	signOut({ commit, state }) {
		const object = {
			cmd: 'logout'
		};
		helperSignOut(object, state);
	},
	changePassword({ commit, state }, { oldPassword, newPassword, userId }) {
		const object = {
			cmd: 'passwd',
			oldPasswd: oldPassword,
			passwd: newPassword
		};
		if (userId !== null) {
			object.idUser = userId;
		}
		return new Promise((resolve, reject) => {
			postToServer(object, state)
				.then((response) => {
					//console.log(response);
					resolve();
				})
				.catch((error) => {
					commit('setError', error);
					reject(error);
				});
		});
	}
};

const getters = {
	isUserLoggedIn: (state) => {
		return state.user !== null;
	},
	getUser: (state) => state.user,
	language: (state) => {
		return state.user.language;
	},
	getConfig: (state) => state.config,
	getError: (state) => state.error,
	getErrorsArray: (state) => state.errorsArray,
	getBase: (state) => state.base,
	getMenu: (state) => state.menu,
	getLoading: (state) => state.loading,
	currentUserDenial: (state) => {
		// console.log('USER DENIAL FIRED');
		let isUser = false;
		if (state.user && state.user.roleid) {
			for (let user of state.userDenial) {
				// console.log(state.user);
				// console.log(user);
				if (+user.roleid === +state.user.roleid) {
					// console.log('in if ', user.deniedLinkNames);
					isUser = true;
					return user.deniedLinkNames;
				}
			}
			if (!isUser && state.user.roletype === "1") {
				// console.log("FOUND SPECIAL USER");
				const specialUser = state.userDenial.find((user) => user.roleid === '-1');
				return specialUser.deniedLinkNames;
			}
			else {
				// если не нашло такую роль -- минимальные права
				const wrongUser = state.userDenial.find((user) => user.roleid === '2');
				// console.log('last user denial', wrongUser);
				return wrongUser.deniedLinkNames;
			}
		}
	},
	theme: (state) => state.theme,
	mainVersion: (state) => state.mainServerVersion,
	userRole: (state, getters) => {
		if (getters.getRolesTableArray.length > 0 && state.user) {
			const userRole = getters.getRolesTableArray.find((role) => role.id === state.user.roleid);
			if (userRole) return userRole.name;
			else return undefined;
		} else return undefined;
	}
};

export default {
	state,
	mutations,
	actions,
	getters
};
